import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { EthernetTooltip } from './ethernet-tooltip';
import { GsmTooltip } from './gsm-tooltip';
import { WifiTooltip } from './wifi-tooltip';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { LegacyDevice } from 'console/device/device';
import { Capability } from '../../device/device-capability';
import { UniversalDialog } from 'console/dialogs/universal';
import { Box } from '@mui/material';
import { ZontContent } from 'console/offline-pane/help-dialog/zont-content';
import branding from 'shared/app/model/branding';
import { selectorSelectedDevice } from 'entities/device/lib';
export const OfflineHelpDialog = React.memo(function OfflineHelpDialog(props) {
    const { open, onClose } = props;
    const selected_device = useAppSelector(selectorSelectedDevice);
    if (selected_device == null) {
        return null;
    }
    const has_wifi = LegacyDevice.has_any_capability(selected_device?.capabilities, [
        Capability.has_wifi,
        Capability.has_wifi_v2,
    ]);
    const has_ethernet = LegacyDevice.has_capability(selected_device.capabilities, Capability.has_ethernet);
    const has_gsm = LegacyDevice.has_capability(selected_device.capabilities, Capability.has_gsm);
    return (_jsx(UniversalDialog, { open: open, onClose: onClose, maxWidth: "sm", title: "\u041F\u043E\u0447\u0435\u043C\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435\u00A0\u043D\u0430\u00A0\u0441\u0432\u044F\u0437\u0438?", closeButtonTitle: "\u041E\u043A", children: branding.enable_asp_billing ? (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [has_gsm && _jsx(GsmTooltip, {}), has_wifi && _jsx(WifiTooltip, {}), has_ethernet && _jsx(EthernetTooltip, {})] })) : (_jsx(ZontContent, { has_gsm: has_gsm, has_wifi: has_wifi, has_ethernet: has_ethernet })) }));
});
